import { Request, POST, GET, PUT, DELETE, PATCH } from './base';

const GetHistory = async (searchParams: string) => await Request('/histories' + searchParams, GET, true);

const historyRest = {
    GetHistory
};

export default historyRest;